import React, { Fragment } from 'react';
import './styles.css';
import {
  PageLayout,
  BupSpinner,
  ContentHTML,
  ErrorMessage
} from '@BUP/components';
import { useWebinar } from '@BUP/hooks';
import { useParams } from 'react-router';
import DefaultWebinarImage from '@BUP/assets/Images/Resources/default_resource.png';
import { Row, Col } from "antd";

const APP_DOMAIN = process.env.REACT_APP_HOST_DOMAIN;

const WebinarDetail = () => {
  const { webinarId } = useParams();
  const {
    data: webinar,
    isLoading: isLoadingWebinar,
    error: errorWebinar,
  } = useWebinar(webinarId);

  if (isLoadingWebinar) return <BupSpinner size="large" />;
  if (errorWebinar) return <ErrorMessage />;

  function youtube_parser(url) {
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    var match = url.match(regExp);
    return match && match[7].length == 11 ? match[7] : false;
  }

  return (
    <PageLayout pageName={`${webinar.name || "Sin Nombre"}`} backButton={true}>
      <div className="webinar-page-container">
        {isLoadingWebinar ?
          (
            <BupSpinner size="large" />
          ) :
          (
            <Fragment>
              <div className="content-html-wrapper">
                <ContentHTML element={{ content: webinar.description }} />
              </div>
              <div>
                {webinar.link ? (
                  <Fragment>
                    <Row>
                      <Col xs={24}>
                        <Row>
                          <Col xs={24}>
                            <div className="video-webinar-container">
                              <iframe
                                width="100%"
                                height="500"
                                src={`https://youtube.com/embed/${youtube_parser(webinar?.link)}`}
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; allowfullscreen"
                              />
                            </div>
                          </Col>
                        </Row>
                        <Row gutter={[8, 8]}>
                          <Col xs={24} md={16}>
                            <div className="chat-container">
                              <iframe
                                width="100%"
                                height="350"
                                src={`https://www.youtube.com/live_chat?v=${youtube_parser(webinar?.link)}&embed_domain=${APP_DOMAIN}`}
                                frameBorder="0"
                                allow="autoplay; encrypted-media"
                              />
                            </div>
                          </Col>
                          <Col xs={24} md={8}>
                            <div className="webinar-survey-documents">
                              <h2>Encuesta de Satisfaccion</h2>
                              <a
                                href={webinar?.survey_link || ""}
                                target="_blank"
                              >
                                <p>Responde Aquí</p>
                              </a>

                              <h2>Documento Descargable</h2>
                              <a
                                href={webinar?.pdfUrl || ""}
                                target="_blank"
                              >
                                <p>Descargalo Aquí</p>
                              </a>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Fragment>
                ) :
                  (
                    <img src={DefaultWebinarImage} alt="webinar-default-img" />
                  )
                }
              </div>
            </Fragment>
          )}
      </div>
    </PageLayout>
  );
};

export default WebinarDetail;
